import { Box, Paper, type PaperProps } from '@mui/material';
import { type PropsWithChildren } from 'react';

export type Props = PropsWithChildren<{
  paper?: PaperProps;
}>;

export default function Global({ paper = {}, children }: Props) {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 4,
        left: 4,
        right: 4,
        minHeight: (theme) => `calc(100vh - ${theme.spacing(8)})`,
        maxWidth: (theme) => `calc(100vw - ${theme.spacing(8)})`,
        b: (theme) => theme.spacing(4),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
      }}
    >
      <Paper
        {...paper}
        sx={{
          width: (theme) => theme.spacing(40),
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          ...paper.sx,
        }}
      >
        {children}
      </Paper>
    </Box>
  );
}
